<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
}

/* ===== 护眼绿豆沙色主题（2026-10-21）=====
   全站列表页白色背景 → 豆沙绿 #C7EDCC；表格白底、悬浮行、斑马纹一并覆盖。
   大屏模式（Home.vue 的 .main-dark 用 !important 压回深色）不受影响；
   el-dialog 弹窗保留白色（长文本可读性）。 */
.app-body > .el-main {
  background-color: #f6f1e7;
}
.el-table,
.el-table__expanded-cell {
  background-color: #f6f1e7;
}
.el-table th.el-table__cell,
.el-table tr,
.el-table td.el-table__cell {
  background-color: #f6f1e7;
}
.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background-color: #f2ecdc;
}
.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: #f0ead8;
}
/* 表头用稍深一档的绿，区分列头与数据行 */
.el-table th.el-table__cell {
  background-color: #efe9d8 !important;
}
/* 查询条件卡片等 el-card 白底统一为暖米白（大屏深色卡片不是 el-card，不受影响） */
.el-card {
  background-color: #f6f1e7;
}
.el-card__header {
  border-bottom: 1px solid #e3dcc8;
}
</style>
